import React, { createContext, useContext, useState, useEffect } from 'react';
import { authApi } from '../config/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [admin, setAdmin] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    const token = localStorage.getItem('adminToken');
    if (!token) {
      setIsLoading(false);
      return;
    }

    try {
      const response = await authApi.getMe();
      setAdmin(response.data);
    } catch (error) {
      localStorage.removeItem('adminToken');
      localStorage.removeItem('adminUser');
    } finally {
      setIsLoading(false);
    }
  };

  const login = async (email, password) => {
    const response = await authApi.login({ email, password });
    const { access_token, admin: adminData } = response.data;
    
    localStorage.setItem('adminToken', access_token);
    localStorage.setItem('adminUser', JSON.stringify(adminData));
    setAdmin(adminData);
    
    return adminData;
  };

  const logout = () => {
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminUser');
    setAdmin(null);
  };

  const hasPermission = (permission) => {
    if (!admin) return false;
    if (admin.role === 'super_admin') return true;
    return admin.permissions?.includes(permission);
  };

  const hasBranchAccess = (locationId) => {
    if (!admin) return false;
    if (admin.role === 'super_admin') return true;
    if (!admin.branch_ids || admin.branch_ids.length === 0) return true;
    return admin.branch_ids.includes(locationId);
  };

  return (
    <AuthContext.Provider value={{
      admin,
      isLoading,
      isAuthenticated: !!admin,
      login,
      logout,
      hasPermission,
      hasBranchAccess,
    }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}
